import { Button } from 'reactstrap'
import PropTypes from 'prop-types'

const IconButton = ({ text, icon, ...rest }) => {
  IconButton.propTypes = {
    text: PropTypes.string,
    icon: PropTypes.object,
  }

  return (
    <Button className="d-flex gap-1 align-items-center justify-content-center" {...rest}>
      {icon}
      {text}
    </Button>
  )
}
export default IconButton
